import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const modulePark = {   //走进园区状态管理
  namespaced:true,
  state:{
    navActive:window.sessionStorage.getItem('parkType')
  },
  mutations:{
    change_nav(state,type){
      state.navActive = type;
      window.sessionStorage.setItem('parkType',type);
    }
  },
  actions: {
    changeNav ({ commit },type) {
      commit('change_nav',type)
    }
  }
}

const moduleEnterPark = {   //入驻园区状态管理
  namespaced:true,
  state:{
    navActive:window.sessionStorage.getItem('enterParkType')
  },
  mutations:{
    change_nav(state,type){
      state.navActive = type;
      window.sessionStorage.setItem('enterParkType',type);
    }
  },
  actions: {
    changeNav ({ commit },type) {
      commit('change_nav',type)
    }
  }
}

const moduleHotspot = {   //园区热点状态管理
  namespaced:true,
  state:{
    navActive:window.sessionStorage.getItem('hotspotType')
  },
  mutations:{
    change_nav(state,type){
      state.navActive = type;
      window.sessionStorage.setItem('hotspotType',type);
    }
  },
  actions: {
    changeNav ({ commit },type) {
      commit('change_nav',type)
    }
  }
}

const moduleService = {     //园区服务状态管理
  namespaced:true,
  state:{
    navActive:window.sessionStorage.getItem('serviceType')
  },
  mutations:{
    change_nav(state,type){
      state.navActive = type;
      window.sessionStorage.setItem('serviceType',type);
    }
  },
  actions: {
    changeNav ({ commit },type) {
      commit('change_nav',type)
    }
  }
}

const moduleWisdom = {     //智慧e家状态管理
  namespaced:true,
  state:{
    navActive:window.sessionStorage.getItem('wisdomType'),
    pageType:window.sessionStorage.getItem('wisdomPage'),
    tabIndex:1
  },
  mutations:{
    change_nav(state,type){
      state.navActive = type;
      window.sessionStorage.setItem('wisdomType',type);
    },
    change_page(state,type){
      state.pageType = type;
      window.sessionStorage.setItem('wisdomPage',type);
    },
    change_tab(state,index){
      state.tabIndex = index
    }
  },
  actions: {
    changeNav ({ commit },type) {
      commit('change_nav',type)
    },
    changePage ({ commit },type) {
      commit('change_page',type)
    },
    changeTab ({ commit },index) {
      commit('change_tab',index)
    }
  }
}

const modulePart = {      //园区党建状态管理
  namespaced:true,
  state:{
    navActive:window.sessionStorage.getItem('partType')
  },
  mutations:{
    change_nav(state,type){
      state.navActive = type;
      window.sessionStorage.setItem('partType',type);
    }
  },
  actions: {
    changeNav ({ commit },type) {
      commit('change_nav',type)
    }
  }
}

const moduleEnterCenter = {      //园区企业中心状态管理
  namespaced:true,
  state:{
    navActive:window.sessionStorage.getItem('enterCenterType'),
    pageType:window.sessionStorage.getItem('enterCenterPage'),
    tabIndex:0
  },
  mutations:{
    change_nav(state,type){
      state.navActive = type;
      window.sessionStorage.setItem('enterCenterType',type);
    },
    change_page(state,type){
      state.pageType = type;
      window.sessionStorage.setItem('enterCenterPage',type);
    },
    change_tab(state,index){
      state.tabIndex = index
    }
  },
  actions: {
    changeNav ({ commit },type) {
      commit('change_nav',type)
    },
    changePage ({ commit },type) {
      commit('change_page',type)
    },
    changeTab ({ commit },index) {
      commit('change_tab',index)
    }
  }
}


const modulePersonCenter = {      //园区个人中心状态管理
  namespaced:true,
  state:{
    navActive:window.sessionStorage.getItem('personCenterType'),
    pageType:window.sessionStorage.getItem('personCenterPage'),
    tabIndex:0
  },
  mutations:{
    change_nav(state,type){
      state.navActive = type;
      window.sessionStorage.setItem('personCenterType',type);
    },
    change_page(state,type){
      state.pageType = type;
      window.sessionStorage.setItem('personCenterPage',type);
    },
  },
  actions: {
    changeNav ({ commit },type) {
      commit('change_nav',type)
    },
    changePage ({ commit },type) {
      commit('change_page',type)
    },

    
  }
}

const store = new Vuex.Store({
  state:{
    isLoading: false,
    token: sessionStorage.getItem('token') || '',
  },
  mutations:{
    updateLoadingStatus (state, data) {
      state.isLoading = data;
    }
  },
  actions: {
    updateLoadingStatus (context) {
      context.commit('updateLoadingStatus',type)
    }
  },
  modules: {
    hotspot: moduleHotspot,
    service: moduleService,
    part:modulePart,
    park:modulePark,
    enterPark:moduleEnterPark,
    wisdom:moduleWisdom,
    enterCenter:moduleEnterCenter,
    personCenter:modulePersonCenter
  }
})

export default store



// WEBPACK FOOTER //
// ./src/utils/store/store.js